import { createGrid, themeQuartz } from 'ag-grid-community'

import makeRows from './make-rows.js'
import makeColumnDefs from './make-columndefs.js'
import './styles.css'

export default function showGrid (params) {
  const { cellsTable, gridContainerId, numberPowTen, groupHeadersMap } = params
  console.log('showGrid', cellsTable)

  const columnNames = cellsTable.reduce((columns, cell) => {
    const columnName = cell.columnName
    if (!columns.includes(columnName)) columns.push(columnName)
    return columns
  }, [])
  console.log('columnNames', columnNames)

  const rows = makeRows(cellsTable, groupHeadersMap)
  console.log('rows', rows)

  const columnDefs = makeColumnDefs({ cellsTable })
  console.log('columnDefs', columnDefs)

  const gridOptions = {
    rowData: rows,
    columnDefs,

    // pinnedTopRowData: [{
    //   code: 'Total',
    //   row: 'Total'
    // }],
    getRowClass: function (params) {
      if (params.data.type === 'subTotal') {
        return 'subTotal'
      } else if (params.data.type === 'header') {
        return 'headerRow'
      } else if (params.data.type === 'break') {
        return 'breakRow'
      }
    },
    getRowHeight: function (params) {
      if (params.data.type === 'break') {
        return 10
      }
    },

    context: {
      numberPowTen
    },

    theme: themeQuartz,

    onCellClicked: function (cellParams) {
      console.log('onCellClicked', cellParams)
    }
  }

  const gridContainerElement = document.getElementById(gridContainerId)
  console.log('gridContainerElement', gridContainerElement)
  gridContainerElement.innerHTML = ''

  const gridApi = createGrid(gridContainerElement, gridOptions)
  console.log('grid created', gridApi)
}
